import ActionItem from '../ActionItem';
import { useTranslations } from 'use-intl';
import { TransactionState } from '@nftx/react';

export type Props = {
  index: number;
  symbol: string;
  status: TransactionState;
  error: any;
  label?: string;
  action: () => void;
};

/** A special action item for handling an approval */
const ApproveItem = ({
  index,
  symbol,
  action,
  error,
  status,
  label,
}: Props) => {
  const t = useTranslations('ActionList');

  return (
    <ActionItem
      index={index}
      label={label || t('item.approve', { symbol })}
      error={error}
      status={status}
      action={action}
    />
  );
};

export default ApproveItem;
